export default {"src":"/_next/static/media/Jcard.4bb3c455.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};